export default __webpack_public_path__ + "static/char-s-37-zh-Hant-2b30960254217d5a974162948dc09219.webp";